class Notify {

  constructor(controllerName) {
    this.controllerName = controllerName;
    this.toast = document.querySelector('#toast')
  }

  emitter(type, detail = undefined) {
    document.dispatchEvent(
      new CustomEvent(`${type}:${this.controllerName}`, { detail })
    );
  }

  notify({ title, message }) {
    this.toast.setAttribute('data-delay', 10000)
    this.toast.querySelector('.toast-title').innerText = title;
    this.toast.querySelector('.toast-body').innerText = message;
    $(toast).toast('show')
  }
}

export { Notify };